import { AppState } from '@core/state';
import { createChildSelectors } from '@util/lib/ngrx-child-selectors';

import { initialState } from './admin.reducers';

export const selectAdminState = (state: AppState) => state.admin;

export const { selectDetail } = createChildSelectors(selectAdminState, initialState);

export const { selectData: selectDetailData } = createChildSelectors(selectDetail, initialState.detail);
